import React from 'react';
import ClassAssembly  from 'views/ClassAssembly11B2023';

const ClassAssemblyPage = () => {
    return <ClassAssembly />;
  };
  
  export default ClassAssemblyPage;